import {
    INIT_CURRENT_MEDIA,
    CURRENT_MEDIA_SOURCE_LOADING,
    CURRENT_MEDIA_SOURCE_LOADED,
    CURRENT_MEDIA_UNAVAILABLE,
    CURRENT_MEDIA_UNSUPPORTED,
    CURRENT_MEDIA_SOURCE_UNLOADED,
} from './actions'
import { set } from 'immutadot'

const initialState = {
    isSourceLoaded: {},
    isSupported: true,
    isAvailable: true,
}

export const currentMedia = (state = initialState, action) => {

    switch (action.type)
    {
        case CURRENT_MEDIA_SOURCE_LOADED:
            return set(state, `isSourceLoaded.${action.viewId}`, true)
        case CURRENT_MEDIA_SOURCE_UNLOADED:
        case CURRENT_MEDIA_SOURCE_LOADING:
            return set(state, `isSourceLoaded.${action.viewId}`, false)
        case INIT_CURRENT_MEDIA:
            return {
                ...state,
                ...action.media,
                isSupported: true,
                isAvailable: true,
            }
        case CURRENT_MEDIA_UNAVAILABLE:
            return {
                ...state,
                isAvailable: false,
            }
        case CURRENT_MEDIA_UNSUPPORTED:
            return {
                ...state,
                isSupported: false,
            }
        default:
            return state
    }
}
